export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.c29ac855.OTF";